import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CommunicationService } from 'src/app/services/Communication/communication.service';

@Component({
  selector: 'app-exam-alert',
  templateUrl: './exam-alert.component.html',
  styleUrls: ['./exam-alert.component.css']
})
export class ExamAlertComponent implements OnInit {

  StudentMarksList:any;
  Submitted:boolean=false;
  SelectUpload:any;
  StudentList:any;
  SubjectList:any;
  GroupMarksList:any;
  GroupContactList:any;
  TemplateList:any;
  numberOfCharacters:any;
  SMSCount:any;

  constructor(private SmsService: CommunicationService, private LookupService: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

    MarksAlertModel = {
      TemplateID:0,
      PersonTypeID:0,
      ExamName: '',
      Message: '',
      MessageType: 'TEXT',
      
  }

   // Upload File

   onUpload(event: any) {
    this.SelectUpload = event.target.files[0];
  }

  // Student

  StudentUploadExamAlert(valid) {
    this.StudentMarksList = [];
    this.StudentMarksList.splice(0);
    this.Submitted = true;
    if (valid && this.SelectUpload != 0) {
      this.spinnerService.show();
        this.SmsService.StudentUploadExamAlert(this.SelectUpload).subscribe((data: any) => {
            this.Submitted = false;
            this.spinnerService.hide();          
            this.StudentList = data.StudentList;
            this.SubjectList = data.SubjectList;
           
            for (var i = 0; i < this.StudentList.length; i++) {             
               var item = {
                    ExamName: this.StudentList[i].ExamName,
                    UserLoginID: this.StudentList[i].UserLoginID,
                    AppRegID: this.StudentList[i].AppRegID,
                    StudentID: this.StudentList[i].StudentID,
                    StudentNo: this.StudentList[i].StudentNo,
                    GRNo: this.StudentList[i].GRNo,
                    Name: this.StudentList[i].Name,
                    Mobile: this.StudentList[i].Mobile,
                    MarkList: this.StudentList[i].MarkList,
                    SubjectMarks:this.StudentList[i].SubjectMarks               
                }
                this.StudentMarksList.push(item);
              }            

        });
    }
}




SendExamAlert(valid) {
  this.Submitted=true;
  if(valid){
     this.spinnerService.show();
      this.SmsService.SendExamAlert(JSON.stringify(this.StudentMarksList), this.MarksAlertModel.MessageType).subscribe((data: any) => {
        this.Submitted=false;  
        this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(data); 
      });
    }
  } 


  ngOnInit() {
     
  }



}
